import { jsPDF } from 'jspdf';
import { formatDisplayDate } from './dashboardData';
import { formatKilos, formatPercent } from './flujoCalculations';
import { drawPdfReportHeader, loadPdfReportLogo } from './pdfReportHeader';

const orange = [255, 121, 0];
const dark = [21, 25, 29];
const muted = [104, 114, 125];
const divider = [220, 224, 228];

const reportRows = [
  { label: 'Kilos volcados', field: 'kilosVolcados', percentage: false },
  { label: 'Retorno II', field: 'retorno' },
  { label: 'Precalibrado', field: 'precalibrado' },
  { label: 'Verde', field: 'verde' },
  { label: 'Rendimiento', field: null, percentageField: 'rendimiento' },
  { label: 'Kilos reales', field: 'kilosReales', percentage: false, dividerBefore: true },
  { label: 'Primera', field: 'primera' },
  { label: 'Industria', field: 'industria' },
  { label: 'Podrido', field: 'podrido' },
  { label: 'Mermas', field: null, percentageField: 'mermas', emphasis: true },
];

const drawValue = (doc, value, x, y, align = 'right') => {
  doc.text(formatKilos(value), x, y, { align });
};

const drawPercent = (doc, value, x, y) => {
  doc.text(`${formatPercent(value)} %`, x, y, { align: 'right' });
};

const drawBalanceBlock = (doc, day, options, top) => {
  doc.setTextColor(...dark);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.text(options.blockLabel, 16, top + 5);
  doc.text(`Fecha: ${formatDisplayDate(day.fecha)}`, 194, top + 5, { align: 'right' });

  doc.setFillColor(248, 249, 250);
  doc.roundedRect(14, top + 9, 182, 12, 1.5, 1.5, 'F');
  doc.setTextColor(...orange);
  doc.setFontSize(8.5);
  doc.text('DIARIOS', 94, top + 14, { align: 'center' });
  doc.text('ACUMULADOS', 158, top + 14, { align: 'center' });
  doc.setTextColor(...muted);
  doc.setFontSize(7.5);
  doc.text('Kilos', 79, top + 19, { align: 'right' });
  doc.text('Porcentaje', 108, top + 19, { align: 'right' });
  doc.text('Kilos', 149, top + 19, { align: 'right' });
  doc.text('Porcentaje', 181, top + 19, { align: 'right' });

  let y = top + 27;
  reportRows.forEach((row) => {
    if (row.dividerBefore) {
      doc.setDrawColor(...divider);
      doc.line(16, y - 3.4, 194, y - 3.4);
    }

    if (row.emphasis) {
      doc.setFillColor(255, 247, 239);
      doc.roundedRect(14, y - 3.5, 182, 6, 1, 1, 'F');
    }

    doc.setTextColor(...dark);
    doc.setFont('helvetica', row.emphasis ? 'bold' : 'normal');
    doc.setFontSize(8);
    doc.text(row.label, 18, y);

    if (row.field) {
      drawValue(doc, day.daily[row.field], 79, y);
      drawValue(doc, day.accumulated[row.field], 149, y);
    }

    const percentageField = row.percentageField || row.field;
    if (row.percentage !== false && percentageField) {
      drawPercent(doc, day.daily.percentages[percentageField], 108, y);
      drawPercent(doc, day.accumulated.percentages[percentageField], 181, y);
    }

    y += 5.2;
  });

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(7.5);
  doc.setTextColor(...muted);
  doc.text('Observaciones:', 16, y + 1);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...dark);
  const observations = day.observations.length > 0 ? day.observations.join(' | ') : 'Sin observaciones';
  const observationLines = doc.splitTextToSize(observations, 148).slice(0, 3);
  doc.text(observationLines, 45, y + 1);
};

const filenamePart = (value) => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[^a-zA-Z0-9]+/g, '-')
  .replace(/^-|-$/g, '')
  .toLowerCase();

export const downloadDailyBalancePdf = async ({ days, ...options }) => {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const totalPages = Math.ceil(days.length / 2);
  const logoDataUrl = await loadPdfReportLogo();

  days.forEach((day, index) => {
    const pageIndex = Math.floor(index / 2);
    const slotIndex = index % 2;

    if (index > 0 && slotIndex === 0) {
      doc.addPage();
    }

    if (slotIndex === 0) {
      drawPdfReportHeader(doc, {
        logoDataUrl,
        pageNumber: pageIndex + 1,
        rightDetail: `Almacenes: ${options.warehouseLabel}`,
        subtitle: `Periodo: ${formatDisplayDate(options.desde)} - ${formatDisplayDate(options.hasta)}`,
        title: options.reportTitle,
        totalPages,
      });
    }

    drawBalanceBlock(doc, day, options, 31 + slotIndex * 126);
  });

  const filename = [
    options.filenamePrefix,
    filenamePart(options.filenameSubject),
    options.desde,
    options.hasta,
  ].filter(Boolean).join('-');

  doc.save(`${filename}.pdf`);
};
